import React, { useState, useEffect } from "react";
import "./progress-bar.scss";

interface ProgressBarProps {
    duration: number;
    onComplete: () => void;
    isMouseDown: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ duration, onComplete, isMouseDown }) => {
    const [progress, setProgress] = useState(100);

    useEffect(() => {
        let interval: NodeJS.Timeout;

        const updateProgress = () => {
            if (!isMouseDown) {
                setProgress((prevProgress) => {
                    const newProgress = prevProgress - 1;
                    if (newProgress <= 0) {
                        clearInterval(interval);
                        onComplete();
                    }
                    return newProgress;
                });
            }
        };

        interval = setInterval(updateProgress, duration / 100);

        return () => clearInterval(interval);
    }, [duration, isMouseDown, onComplete]);

    return (
        <div className="progress-bar-container">
            <div className="progress-bar" style={{ width: `${progress}%` }}></div>
        </div>
    );
};

export default ProgressBar;
